import { useInstance } from '@meraki-internal/react-dependency-injection';
import { FeatureFlagState, IFeatureFlag } from './FeatureFlagState';
import { useSubscription } from '@meraki-internal/state';

export const IfFeatureFlag: React.FC<{ children: React.ReactNode; flag: IFeatureFlag; }> = ({ children, flag })=> {
    const flagState = useInstance(FeatureFlagState);
    useSubscription(() => flagState);

    if (!flagState.getFlagValue(flag)){
        return null;
    }

    return children;
};
